import Parse from 'parse';

export class InitializeUser {
  static readonly type = '[User] Initialize from Parse';
}

export class SetCurrentUser {
  static readonly type = '[User] Set Current User';
  constructor(public user: Parse.User | null | undefined) {}
}

export class LogoutUser {
  static readonly type = '[User] Logout';
}

export class ResetStateUser {
  static readonly type = '[User] Reset state';
}
